import Icon from '../components/Icon.vue'

Icon.register({
  infinity: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M471.1 96c93.1 0 168.9 71.8 168.9 160s-75.8 160-168.9 160c-66.1 0-117.8-41.3-151.1-78.6-33.3 37.3-85 78.6-151.1 78.6-93.1 0-168.9-71.8-168.9-160s75.8-160 168.9-160c66.1 0 117.8 41.3 151.1 78.6 33.3-37.3 85-78.6 151.1-78.6zM168.9 320c38.1 0 73.6-36.4 94-64-20.6-27.9-55.8-64-94-64-40.2 0-72.9 28.7-72.9 64s32.7 64 72.9 64zM471.1 320c40.2 0 72.9-28.7 72.9-64s-32.7-64-72.9-64c-38.1 0-73.6 36.4-94 64 20.6 27.9 55.8 64 94 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/infinity.js
// module id = 1488
// module chunks = 0